import {
  DEBUG_LOGGING,
} from '../actions/settings'

const configFlags = (typeof window !== 'undefined' && window.config && window.config.featureFlags) || []
const persistedDebugFlag = typeof localStorage !== 'undefined' ? localStorage.getItem('wm.showDebugLogs') === 'true' : false

const initialState = {
  showDebugLogs: configFlags.indexOf('enableMonitorDebugLogging') >= 0 && persistedDebugFlag,
}

export default function settings(state = initialState, action) {
  switch (action.type) {
    case DEBUG_LOGGING:
      return { ...state, showDebugLogs: action.value }
    default:
      return state
  }
}
